import { createStyles } from '@/contexts/theme-context';
import { Platform, View } from 'react-native';
import { RestaurantInfoHeaderSkeleton } from './restaurant-info-header-skeleton';

export const CurrentOrdersListSkeleton: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
      accessible
      style={styles.container}
    >
      {[...Array(Platform.OS === 'web' ? 5 : 3)].map((_, index) => (
        <RestaurantInfoHeaderSkeleton key={index} />
      ))}
    </View>
  );
};

const useStyles = createStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    justifyContent: 'center',
    width: '100%',
  },
}));
